const initials = "cart";

export const UPDATE_CART = `${initials}UPDATE_CART`;
export const UPDATE_CART_REFERRAL = `${initials}UPDATE_CART_REFERRAL`;
export const UPDATE_CART_COUPON = `${initials}UPDATE_CART_COUPON`;